import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from 'src/app/_services/dashboard.service';

export interface AlertKpiConfig {
  minOccurrences: number;
  selectedTypes: string[];
}

@Component({
  selector: 'app-alert-config-modal',
  templateUrl: './alert-config-modal.component.html',
  styleUrls: ['./alert-config-modal.component.css']
})
export class AlertConfigModalComponent implements OnInit {
  @Input() currentConfig: AlertKpiConfig = { minOccurrences: 0, selectedTypes: [] };

  availableTypes: string[] = [];
  loadingTypes = true;
  minOccurrences = 0;
  selectedTypes: Set<string> = new Set();

  constructor(
    public activeModal: NgbActiveModal,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.minOccurrences = this.currentConfig.minOccurrences ?? 0;
    this.selectedTypes = new Set(this.currentConfig.selectedTypes ?? []);

    this.dashboardService.getAlertSensitiveTypes().subscribe({
      next: res => {
        const all = res.body ?? [];
        this.availableTypes = [
          ...all.filter(t => this.selectedTypes.has(t)),
          ...all.filter(t => !this.selectedTypes.has(t)),
        ];
        this.loadingTypes = false;
      },
      error: () => { this.loadingTypes = false; }
    });
  }

  toggleType(name: string) {
    if (this.selectedTypes.has(name)) this.selectedTypes.delete(name);
    else this.selectedTypes.add(name);
  }

  isSelected(name: string): boolean {
    return this.selectedTypes.has(name);
  }

  clearAll() { this.selectedTypes.clear(); }

  get hasActiveFilters(): boolean {
    return this.minOccurrences > 0 || this.selectedTypes.size > 0;
  }

  apply() {
    const config: AlertKpiConfig = {
      minOccurrences: this.minOccurrences,
      selectedTypes: Array.from(this.selectedTypes)
    };
    this.activeModal.close(config);
  }

  reset() {
    this.minOccurrences = 0;
    this.selectedTypes.clear();
    this.activeModal.close({ minOccurrences: 0, selectedTypes: [] } as AlertKpiConfig);
  }

  dismiss() { this.activeModal.dismiss(); }
}
